var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { Wrapper } from 'app/components/styles/districtModules/headerStyles';
import { FONTS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { Heading } from 'app/components/competitionModule/header/headerStyles';
import SponsorAdSlot from 'app/components/ads/SponsorAdSlot';
const ImageContainer = styled.div.withConfig({
  componentId: "sc-1u4j4s6-0"
})(["display:flex;justify-content:center;align-items:center;height:", ";width:", ";margin-right:", ";"], SIZES['32'], SIZES['32'], SIZES['8']);
const Title = styled(Typography).withConfig({
  componentId: "sc-1u4j4s6-1"
})(["&&&{", "}"], props => props.theme.streamModuleFourElemsPerViews(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        font-size: ", ";\n        line-height: ", ";\n      "])), FONTS['18'], SIZES['24']));
export default function CompetitionModuleHeader(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleHeader",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Competition,
    src: data.image,
    ratio: "1:1",
    width: 32,
    height: 32,
    fit: true,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    to: data.getLinkToCompetition(),
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, data.longName)), /*#__PURE__*/React.createElement(SponsorAdSlot, {
    extendSlotId: data.id,
    "data-sentry-element": "SponsorAdSlot",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }));
}